import { useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { GuardProvider, GuardedRoute } from "react-router-guards";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import Header from "./components/Header";
import history from "./history";
import Aplicacao from "./pages/seidor/Aplicacao";
import Business from "./pages/concur/Business";
import ConcurPage from "./pages/concur/ConcurPage";
import DashBoard from "./pages/seidor/DashBoard";
import Login from "./pages/auth/Login";
import Logs from "./pages/concur/Logs";
import Main, { routePermissions } from "./pages/Main";
import NewPassword from "./pages/auth/NewPassword";
import AdminConcurControlApplication from "./pages/admin/concur/admin-concur-control-applications";
import AdminUsers from "./pages/admin/users";
import AplicacaoSourcing from "./pages/ariba/Aplicacao";
import AplicacaoAribaGroup from "./pages/ariba/Groups";
import AribaLogs from "./pages/ariba/logs";
import AribaResponseErrors from "./pages/ariba/ResponseErrors";
import AribaDashboardMetrics from "./pages/ariba/DashboardMetrics";
import AplicacaoComerzzia from "./pages/comerzzia/Aplicacao";
import AplicacaoComerzziaGroup from "./pages/comerzzia/Groups";
import NotificacoesComerzzia from "./pages/comerzzia/Notificacoes";
import UsageComerzzia from "./pages/comerzzia/UsagePage";
import DashboardComerzzia from "./pages/comerzzia/DashboardPage";
import WorkerDashboard from "./pages/comerzzia/WorkerDashboard";
import AplicacaoIFS from "./pages/ifs/Aplicacao";
import AplicacaoIFSGroup from "./pages/ifs/Groups";
import IFSQueuePage from "./pages/ifs/Queue";
import IFSLogs from "./pages/ifs/Logs";
import SincronizarEstoque from "./pages/ifs/SincronizarEstoque";
import DashboardConcur from "./pages/concur/dashboard";
import AplicacaoEconodata from "./pages/econodata/importacao";
import E1Dashboard from "./pages/e1/Dashboard";
import E1DashboardConsolidado from "./pages/e1/DashboardConsolidado";
import AplicacaoWmsGroups from "./pages/senior/wms/groups";
import SeniorLogs from "./pages/senior/wms/logs";
import AplicacaoWms from "./pages/senior/wms/wmsList";
import WmsDashboardMetrics from "./pages/senior/wms/DashboardMetrics";
import NotificacoesWms from "./pages/senior/wms/Notificacoes";
import AplicacaoViceri from "./pages/viceri/Aplicacao";
import LogsViceri from "./pages/viceri/Logs";
import DashboardViceri from "./pages/viceri/dashboard";
import Unauthorized from "./pages/Unauthorized";
function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  const verifyPermssionUser = async (to, from, next) => {
    const pathname = to.history.location.pathname;
    if (pathname === "/") return next();
    try {
      const { permission } = JSON.parse(localStorage.getItem("user"));
      const perms = Array.isArray(permission)
        ? permission
        : String(permission || "")
            .split("|")
            .map((p) => p.trim())
            .filter(Boolean);

      // Acesso total libera todas as rotas, incluindo admin
      if (perms.includes("acesso-total")) {
        next();
        return;
      }

      // Checagem exata pela permissão específica da rota (não substring),
      // para que ter a permissão "geral" de um card (ex.: "ariba") não
      // libere sub-rotas mais restritas (ex.: "/ariba/metrics"). Rotas sem
      // mapeamento são negadas por padrão.
      const requiredPermission = routePermissions[pathname];
      const check = Boolean(requiredPermission) && perms.includes(requiredPermission);
      if (check) next();
      else next.redirect("/unauthorized");
    } catch (error) {
      console.log("error");
      console.log(error);
      next.redirect("/unauthorized");
    }
  };

  return (
    <Router history={history}>
      {!user ? (
        <Switch>
          <Route path="/newpassword" exact>
            <NewPassword setUser={setUser} />
          </Route>
          <Route path="/" exact>
            <Login setUser={setUser} />
          </Route>
        </Switch>
      ) : (
        <GuardProvider guards={[verifyPermssionUser]}>
          <Container>
            <Header
              setUser={setUser}
              email={user.email}
              username={user.username}
              nickname={user.nickname}
            />
            {/* always ad the path in concur-aplicacao-permissao */}
            <Switch>
              <GuardedRoute path="/concur/logs" exact>
                <Logs />
              </GuardedRoute>
              <GuardedRoute path="/viceri/dashboard" exact>
                <DashboardViceri />
              </GuardedRoute>
              <GuardedRoute path="/viceri/aplicacoes" exact>
                <AplicacaoViceri />
              </GuardedRoute>
              <GuardedRoute path="/viceri/logs" exact>
                <LogsViceri />
              </GuardedRoute>
              <GuardedRoute path="/concur/empresas" exact>
                <Business />
              </GuardedRoute>
              <GuardedRoute path="/concur" exact>
                <ConcurPage />
              </GuardedRoute>
              <GuardedRoute path="/concur/dashboard" exact>
                <DashboardConcur />
              </GuardedRoute>
              <GuardedRoute path="/seidor/aplicacao" exact>
                <Aplicacao />
              </GuardedRoute>
              <GuardedRoute path="/seidor/dashboard" exact>
                <DashBoard />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/aplicacoes" exact>
                <AplicacaoComerzzia />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/grupos" exact>
                <AplicacaoComerzziaGroup />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/notificacoes" exact>
                <NotificacoesComerzzia />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/usage" exact>
                <UsageComerzzia />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/dashboard" exact>
                <DashboardComerzzia />
              </GuardedRoute>
              <GuardedRoute path="/comerzzia/worker" exact>
                <WorkerDashboard />
              </GuardedRoute>
              <GuardedRoute path="/ifs/aplicacoes" exact>
                <AplicacaoIFS />
              </GuardedRoute>
              <GuardedRoute path="/ifs/grupos" exact>
                <AplicacaoIFSGroup />
              </GuardedRoute>
              <GuardedRoute path="/ifs/queue" exact>
                <IFSQueuePage />
              </GuardedRoute>
              <GuardedRoute path="/ifs/logs" exact>
                <IFSLogs />
              </GuardedRoute>
              <GuardedRoute path="/ifs/sincronizar-estoque" exact>
                <SincronizarEstoque />
              </GuardedRoute>
              <GuardedRoute path="/senior/wms/grupos" exact>
                <AplicacaoWmsGroups />
              </GuardedRoute>
              <GuardedRoute path="/senior/wms/logs" exact>
                <SeniorLogs />
              </GuardedRoute>
              <GuardedRoute path="/admin/users" exact>
                <AdminUsers />
              </GuardedRoute>
              <GuardedRoute path="/admin/concur" exact>
                <AdminConcurControlApplication />
              </GuardedRoute>
              <GuardedRoute path="/econodata/import" exact>
                <AplicacaoEconodata />
              </GuardedRoute>
              <GuardedRoute path="/senior/wms/dashboard" exact>
                <WmsDashboardMetrics />
              </GuardedRoute>
              <GuardedRoute path="/senior/wms/notificacoes" exact>
                <NotificacoesWms />
              </GuardedRoute>
              <GuardedRoute path="/senior/wms" exact>
                <AplicacaoWms />
              </GuardedRoute>
              <GuardedRoute path="/ariba/sourcing" exact>
                <AplicacaoSourcing />
              </GuardedRoute>
              <GuardedRoute path="/ariba/sourcing/grupos" exact>
                <AplicacaoAribaGroup />
              </GuardedRoute>
              <GuardedRoute path="/ariba/logs" exact>
                <AribaLogs />
              </GuardedRoute>
              <GuardedRoute path="/ariba/response-errors" exact>
                <AribaResponseErrors />
              </GuardedRoute>
              <GuardedRoute path="/ariba/metrics" exact>
                <AribaDashboardMetrics />
              </GuardedRoute>
              <GuardedRoute path="/e1/dashboard" exact>
                <E1Dashboard />
              </GuardedRoute>
              <GuardedRoute path="/e1/dashboard-consolidado" exact>
                <E1DashboardConsolidado />
              </GuardedRoute>
              <Route path="/unauthorized" exact>
                <Unauthorized />
              </Route>
              <GuardedRoute path="/" exact>
                <Main user={user} />
              </GuardedRoute>
            </Switch>
          </Container>
        </GuardProvider>
      )}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
        style={{ marginTop: '65px' }}
      />
    </Router>
  );
}

export default App;

const Container = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
`;
